class t {
  constructor(o) {
    (this.host = o).addController(this);
  }
  hostConnected() {
    const o = this.host.tagName.toLowerCase();
    console.warn(
      `%c[PWC Warning] You are using a beta component: <${o}>.`,
      "color: darkorange; font-weight: bold;",
      `

<${o}> is currently in beta and may undergo significant changes. Use it cautiously in production environments, and check for updates regularly.`
    );
  }
}
export {
  t as B
};
